const SearchBar = ({ searchQuery, setSearchQuery }) => (
  <div className="relative w-full">
    <input
      type="text"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      placeholder="Search for consoles, games, accessories..."
      className="w-full py-3 px-4 pl-12 rounded-xl bg-gradient-to-br mb-4 from-[#1a1a2e] via-[#16213e] to-[#0f3460] text-white border border-cyan-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-cyan-500 shadow-md"
    />
    <span className="absolute left-4 top-1/3 transform -translate-y-1/2 text-cyan-400 ">
      🔍
    </span>
  </div>
);

export default SearchBar;
